// Small adapter to shape trial gating metrics for chart components
// Input: server response from /origin/anti-abuse/trial-gating-metrics
// Output: simplified series and KPIs

export function adaptTrialGating(response){
  const kpis = {
    totalDenied: response?.totals?.totalDenied || 0,
    totalGranted: response?.totals?.granted || 0,
    denialRatePct: response?.denialRatePct || 0,
    deviceIpDenied: response?.deviceIp?.totalDeniedDueToDeviceOrIP || 0
  };
  const reasons = (response?.reasons || []).map(r => ({ label: r.reason, value: r.count }));
  const daily = (response?.daily || []).map(d => ({ date: d.date, denied: d.denied || 0, granted: d.granted || 0 }));
  const dailyDeviceIp = (response?.deviceIp?.daily || []).map(d => ({ date: d.date, deviceIpDenied: d.deviceIpDenied || 0 }));
  return { kpis, reasons, daily, dailyDeviceIp };
}
